export default __webpack_public_path__ + "c53ad5bee57c1cecbb24dc7dced62ca2.png";